export type TStrParams = {
    params__key?: string[]
    params__str_value?: string[]
}

export const getAnalyticsParams = (
    record: Record<string, string | null | undefined>,
): TStrParams => {
    const entries = Object.entries(record).filter((entry): entry is [string, string] =>
        Boolean(entry[1]),
    )

    if (entries.length === 0) {
        return {}
    }

    return {
        params__key: entries.map(([key]) => key),
        params__str_value: entries.map(([, value]) => value),
    }
}
